import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../../Assets/logo.png";

const Navbar = () => {
    return (
        <div>
            <div className="flex items-center flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75">
                <img src={logo} className="h-10 w-10" alt="logo" />
                <div className="ml-10">
                    <NavLink
                        className="mx-2 text-sm font-semibold text-indigo-700"
                        to="/teams"
                    >
                        Team
                    </NavLink>
                    <NavLink
                        className="mx-2 text-sm font-semibold text-gray-600 hover:text-indigo-700"
                        to="/projects"
                    >
                        Projects
                    </NavLink>
                </div>
                <button className="flex items-center justify-center w-8 h-8 ml-auto overflow-hidden rounded-full cursor-pointer">
                    <img
                        src="https://assets.codepen.io/5041378/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1600304177&width=512"
                        alt=""
                    />
                </button>
            </div>
        </div>
    );
};

export default Navbar;
